"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypedEventBusClient = void 0;
const serialization_1 = require("../serialization");
const __1 = require("../../..");
const NANOSEC_PER_MILLISEC = 1000000;
class TypedEventBusClient {
    constructor(eventBusClient) {
        this.eventBusClient = eventBusClient;
    }
    publishState(topic, state, serialize) {
        this.publishMessage(topic, (0, __1.serializeState)(state, serialize), __1.MessageQoS.AtMostOnce);
    }
    publishEvent(topic, event, serialize) {
        this.publishMessage(topic, (0, __1.serializeEvent)(event, serialize), __1.MessageQoS.ExactlyOnce);
    }
    subscribeState(topic, handler, deserialize) {
        const deserializeAndRunHandler = (message) => {
            const copy = JSON.parse(message);
            copy.entity = deserialize(JSON.stringify(copy.entity));
            copy.state_timestamp = copy.state_timestamp
                ? new Date(copy.state_timestamp / NANOSEC_PER_MILLISEC)
                : undefined;
            handler(copy);
        };
        this.subscribe(topic, deserializeAndRunHandler, __1.MessageQoS.AtMostOnce);
    }
    subscribeEvent(topic, handler, deserialize) {
        const deserializeAndRunHandler = (message) => {
            const copy = JSON.parse(message);
            copy.entity = deserialize(JSON.stringify(copy.entity));
            copy.event_timestamp = copy.event_timestamp
                ? new Date(copy.event_timestamp / NANOSEC_PER_MILLISEC)
                : undefined;
            handler(copy);
        };
        this.subscribe(topic, deserializeAndRunHandler, __1.MessageQoS.ExactlyOnce);
    }
    publishMessage(topic, message, qos) {
        this.eventBusClient.publishMessage(topic, message, qos);
    }
    subscribe(topic, handler, qos) {
        this.eventBusClient.subscribe(topic, handler, qos);
    }
    getConnected() {
        return this.eventBusClient.getConnected();
    }
    getConnectionsSinceLastBoot() {
        return this.eventBusClient.getConnectionsSinceLastBoot();
    }
    publishChargerControlCharging(state) {
        this.publishState("State_ChargerControlCharging", state, serialization_1.ChargerControlChargingSerialization.serialize);
    }
    publishChargerControlActiveTransactions(state) {
        this.publishState("State_ChargerControlActiveTransactions", state, serialization_1.ChargerControlActiveTransactionsSerialization.serialize);
    }
    publishChargerControlOcppAuthorizedTransactions(state) {
        this.publishState("State_ChargerControlOcppAuthorizedTransactions", state, serialization_1.ChargerControlOcppAuthorizedTransactionsSerialization.serialize);
    }
    publishChargingSessionTracker(state) {
        this.publishState("State_ChargingSessionTracker", state, serialization_1.ChargingSessionTrackerSerialization.serialize);
    }
    publishChargerControlActiveSessionAttempts(state) {
        this.publishState("State_ChargerControlActiveSessionAttempts", state, serialization_1.ChargerControlActiveSessionAttemptsSerialization.serialize);
    }
    publishChargingTransactionTelemetryTracker(state) {
        this.publishState("State_ChargingTransactionTelemetryTracker", state, serialization_1.ChargingTransactionTelemetryTrackerSerialization.serialize);
    }
    publishReceiptChargingSessionAttempts(state) {
        this.publishState("State_ReceiptChargingSessionAttempts", state, serialization_1.ReceiptChargingSessionAttemptsSerialization.serialize);
    }
    publishChargerControlCtepParameterLog(state) {
        this.publishState("State_ChargerControlCtepParameterLog", state, serialization_1.ChargerControlCtepParameterLogSerialization.serialize);
    }
    publishPaymentTerminalControlActivePayments(state) {
        this.publishState("State_PaymentTerminalControlActivePayments", state, serialization_1.PaymentTerminalControlActivePaymentsSerialization.serialize);
    }
    publishPaymentTerminalControlProcessingPayments(state) {
        this.publishState("State_PaymentTerminalControlProcessingPayments", state, serialization_1.PaymentTerminalControlProcessingPaymentsSerialization.serialize);
    }
    publishPaymentTerminalControlCompletedPayments(state) {
        this.publishState("State_PaymentTerminalControlCompletedPayments", state, serialization_1.PaymentTerminalControlCompletedPaymentsSerialization.serialize);
    }
    publishPaymentTerminalControlPendingPreauths(state) {
        this.publishState("State_PaymentTerminalControlPendingPreauths", state, serialization_1.PaymentTerminalControlPendingPreauthsSerialization.serialize);
    }
    publishPaymentTerminalControlCachedPaymentMethod(state) {
        this.publishState("State_PaymentTerminalControlCachedPaymentMethod", state, serialization_1.PaymentTerminalControlCachedPaymentSerialization.serialize);
    }
    publishPaymentTerminalControlActiveMemberships(state) {
        this.publishState("State_PaymentTerminalControlActiveMemberships", state, serialization_1.PaymentTerminalControlActiveMembershipsSerialization.serialize);
    }
    publishPaymentTerminalControlPresentedPayments(state) {
        this.publishState("State_PaymentTerminalControlPresentedPayments", state, serialization_1.PaymentTerminalControlPresentedPaymentsSerialization.serialize);
    }
    publishChargerControlChargerConfiguration(state) {
        this.publishState("State_ChargerControlChargerConfiguration", state, serialization_1.ChargerConfigurationSerialization.serialize);
    }
    publishChargerControlChargerStatus(state) {
        this.publishState("State_ChargerControlChargerStatus", state, serialization_1.ChargerStatusSerialization.serialize);
    }
    publishChargerControlCloudChargerOperatingStatus(state) {
        this.publishState("State_ChargerControlCloudChargerOperatingStatus", state, serialization_1.CloudChargerOperatingStatusSerialization.serialize);
    }
    publishChargerControlPricing(state) {
        this.publishState("State_ChargerControlPricing", state, serialization_1.money_PricingModelSerialization.serialize);
    }
    publishPaymentTerminalControlTerminalStatus(state) {
        this.publishState("State_PaymentTerminalControlTerminalStatus", state, serialization_1.PaymentTerminalControlTerminalStatusSerialization.serialize);
    }
    publishPaymentTerminalControlMetrics(state) {
        this.publishState("State_PaymentTerminalControlMetrics", state, serialization_1.PaymentTerminalControlMetricsSerialization.serialize);
    }
    publishChargerUIActivePort(state) {
        this.publishState("State_ChargerUIActivePort", state, serialization_1.ChargerUIActivePortSerialization.serialize);
    }
    publishChargerUIFullscreenTakeover(state) {
        this.publishState("State_ChargerUIFullscreenTakeover", state, serialization_1.ChargerUIFullscreenTakeoverSerialization.serialize);
    }
    publishChargerUIStatus(state) {
        this.publishState("State_ChargerUIStatus", state, serialization_1.ChargerUIStatusSerialization.serialize);
    }
    publishChargerControlUIScreenStatus(state) {
        this.publishState("State_ChargerControlUIScreenStatus", state, serialization_1.ChargerControlUIScreenStatusSerialization.serialize);
    }
    publishChargerControlTransactionStatus(state) {
        this.publishState("State_ChargerControlTransactionStatus", state, serialization_1.ChargerControlTransactionStatusSerialization.serialize);
    }
    publishSimDispenserControlSafetyMicro(state) {
        this.publishState("State_SimDispenserControlSafetyMicro", state, serialization_1.SimDispenserControlSafetyMicroOutSerialization.serialize);
    }
    publishSimDispenserControlHvPs(state) {
        this.publishState("State_SimDispenserControlHvPs", state, serialization_1.SimDispenserControlHvPsOutSerialization.serialize);
    }
    publishSimDispenserControlEvseCommands(state) {
        this.publishState("State_SimDispenserControlEvseCommands", state, serialization_1.SimDispenserControlEvseCommandsSerialization.serialize);
    }
    publishTestRackPowerSourceCommand(state) {
        this.publishState("State_TestRackPowerSourceCommand", state, serialization_1.TestRackPowerCommandSerialization.serialize);
    }
    publishTestRackPowerSourceStatus(state) {
        this.publishState("State_TestRackPowerSourceStatus", state, serialization_1.TestRackPowerStatusSerialization.serialize);
    }
    publishTestRackPowerSinkCommand(state) {
        this.publishState("State_TestRackPowerSinkCommand", state, serialization_1.TestRackPowerCommandSerialization.serialize);
    }
    publishTestRackPowerSinkStatus(state) {
        this.publishState("State_TestRackPowerSinkStatus", state, serialization_1.TestRackPowerStatusSerialization.serialize);
    }
    publishTestRackRelayCommand(state) {
        this.publishState("State_TestRackRelayCommand", state, serialization_1.TestRackRelaysSerialization.serialize);
    }
    publishTestRackRelayStatus(state) {
        this.publishState("State_TestRackRelayStatus", state, serialization_1.TestRackRelaysSerialization.serialize);
    }
    publishTestRackEvGpioCommand(state) {
        this.publishState("State_TestRackEvGpioCommand", state, serialization_1.TestRackEvGpioCommandSerialization.serialize);
    }
    publishTestRackEvStatus(state) {
        this.publishState("State_TestRackEvStatus", state, serialization_1.TestRackEvStatusSerialization.serialize);
    }
    publishChargerControlPluggedIn(event) {
        this.publishEvent("Event_ChargerControlPluggedIn", event, serialization_1.ChargerControlChargingPortStateSerialization.serialize);
    }
    publishMembershipPresented(event) {
        this.publishEvent("Event_MembershipPresented", event, serialization_1.MembershipTransactionSerialization.serialize);
    }
    publishMembershipError(event) {
        this.publishEvent("Event_MembershipError", event, serialization_1.MembershipTransactionSerialization.serialize);
    }
    publishMembershipValidated(event) {
        this.publishEvent("Event_MembershipValidated", event, serialization_1.MembershipTransactionSerialization.serialize);
    }
    publishPaymentPresented(event) {
        this.publishEvent("Event_PaymentPresented", event, serialization_1.PaymentTransactionSerialization.serialize);
    }
    publishPaymentAuthorized(event) {
        this.publishEvent("Event_PaymentAuthorized", event, serialization_1.PaymentTransactionSerialization.serialize);
    }
    publishPaymentAuthorizationError(event) {
        this.publishEvent("Event_PaymentAuthorizationError", event, serialization_1.PaymentTransactionSerialization.serialize);
    }
    publishPaymentExpired(event) {
        this.publishEvent("Event_PaymentExpired", event, serialization_1.PaymentTransactionSerialization.serialize);
    }
    publishPaymentCancelled(event) {
        this.publishEvent("Event_PaymentCancelled", event, serialization_1.PaymentTransactionSerialization.serialize);
    }
    publishPaymentCaptureError(event) {
        this.publishEvent("Event_PaymentCaptureError", event, serialization_1.PaymentTransactionSerialization.serialize);
    }
    publishPaymentCaptureDeferred(event) {
        this.publishEvent("Event_PaymentCaptureDeferred", event, serialization_1.PaymentTransactionSerialization.serialize);
    }
    publishUseMembershipAsPayment(event) {
        this.publishEvent("Event_UseMembershipAsPayment", event, serialization_1.PortRequestSerialization.serialize);
    }
    publishSkipMembershipValidation(event) {
        this.publishEvent("Event_SkipMembershipValidation", event, serialization_1.PortRequestSerialization.serialize);
    }
    publishConfirmMembershipInformProceed(event) {
        this.publishEvent("Event_ConfirmMembershipInformProceed", event, serialization_1.PortRequestSerialization.serialize);
    }
    publishRequestMembershipValidation(event) {
        this.publishEvent("Event_RequestMembershipValidation", event, serialization_1.MembershipIdentifierSubmissionSerialization.serialize);
    }
    publishRegisterMemberIdentifier(event) {
        this.publishEvent("Event_RegisterMemberIdentifier", event, serialization_1.MembershipIdentifierSubmissionSerialization.serialize);
    }
    publishRequestOcppIdTokenAuthorization(event) {
        this.publishEvent("Event_RequestOcppIdTokenAuthorization", event, serialization_1.OcppIdTokenAuthorizationSerialization.serialize);
    }
    publishOcppIdTokenAuthorizationResolved(event) {
        this.publishEvent("Event_OcppIdTokenAuthorizationResolved", event, serialization_1.OcppIdTokenAuthorizationSerialization.serialize);
    }
    publishCancelTransaction(event) {
        this.publishEvent("Event_CancelTransaction", event, serialization_1.PortRequestSerialization.serialize);
    }
    publishStopChargingSessionRequest(event) {
        this.publishEvent("Event_StopChargingSessionRequest", event, serialization_1.PortRequestSerialization.serialize);
    }
    publishChargingTransactionCompleted(event) {
        this.publishEvent("Event_ChargingTransactionCompleted", event, serialization_1.ChargingSessionAttemptSerialization.serialize);
    }
    publishPaymentTerminalControlPaymentCompleted(event) {
        this.publishEvent("Event_PaymentTerminalControlPaymentCompleted", event, serialization_1.PaymentTransactionSerialization.serialize);
    }
    publishGenerateReceipt(event) {
        this.publishEvent("Event_GenerateReceipt", event, serialization_1.GenerateReceiptSerialization.serialize);
    }
    publishChargerUIChangeActivePort(event) {
        this.publishEvent("Event_ChargerUIChangeActivePort", event, serialization_1.ChargerUIActivePortSerialization.serialize);
    }
    publishChargerUISendFeedback(event) {
        this.publishEvent("Event_ChargerUISendFeedback", event, serialization_1.ChargerUISendFeedbackSerialization.serialize);
    }
    publishChargerUISendOnScreenValidationFeedback(event) {
        this.publishEvent("Event_ChargerUISendOnScreenValidationFeedback", event, serialization_1.ChargerUISendOnScreenValidationFeedbackSerialization.serialize);
    }
    publishReceivedOcpiTrackingId(event) {
        this.publishEvent("Event_ReceivedOcpiTrackingId", event, serialization_1.ReceivedOcpiTrackingIdSerialization.serialize);
    }
    publishPaymentTerminalControlEMVCardPayload(event) {
        this.publishEvent("Event_PaymentTerminalControlEMVCardPayload", event, serialization_1.PaymentTerminalControlEMVCardPayloadSerialization.serialize);
    }
    publishPaymentTerminalControlRequestCardPaymentCapture(event) {
        this.publishEvent("Event_PaymentTerminalControlRequestCardPaymentCapture", event, serialization_1.PaymentTransactionSerialization.serialize);
    }
    publishSimChargerControlPluggedIn(event) {
        this.publishEvent("Event_SimChargerControlPluggedIn", event, serialization_1.ChargerControlChargingPortStateSerialization.serialize);
    }
    publishSimPaymentTerminalControlPayment(event) {
        this.publishEvent("Event_SimPaymentTerminalControlPayment", event, serialization_1.SimulationPaymentSerialization.serialize);
    }
    publishSimChargerControlDeratingReason(event) {
        this.publishEvent("Event_SimChargerControlDeratingReason", event, serialization_1.SimChargerControlDeratingReasonStateSerialization.serialize);
    }
    publishSimChargerControlErrorCode(event) {
        this.publishEvent("Event_SimChargerControlErrorCode", event, serialization_1.SimChargerControlErrorCodeStateSerialization.serialize);
    }
    publishDiscoControlManualCommand(event) {
        this.publishEvent("Event_DiscoControlManualCommand", event, serialization_1.DispenserControlManualCommandsSerialization.serialize);
    }
    publishCoolioManualCommand(event) {
        this.publishEvent("Event_CoolioManualCommand", event, serialization_1.CoolioManualCommandsSerialization.serialize);
    }
    publishSksgV2FirmwareUpdateCommand(event) {
        this.publishEvent("Event_SksgV2FirmwareUpdateCommand", event, serialization_1.SksgV2FirmwareUpdateCommandSerialization.serialize);
    }
    publishSksgV2RebootCommand(event) {
        this.publishEvent("Event_SksgV2RebootCommand", event, serialization_1.SksgV2RebootCommandSerialization.serialize);
    }
    subscribeChargerControlCharging(handler) {
        this.subscribeState("State_ChargerControlCharging", handler, serialization_1.ChargerControlChargingSerialization.deserialize);
    }
    subscribeChargerControlActiveTransactions(handler) {
        this.subscribeState("State_ChargerControlActiveTransactions", handler, serialization_1.ChargerControlActiveTransactionsSerialization.deserialize);
    }
    subscribeChargerControlOcppAuthorizedTransactions(handler) {
        this.subscribeState("State_ChargerControlOcppAuthorizedTransactions", handler, serialization_1.ChargerControlOcppAuthorizedTransactionsSerialization.deserialize);
    }
    subscribeChargingSessionTracker(handler) {
        this.subscribeState("State_ChargingSessionTracker", handler, serialization_1.ChargingSessionTrackerSerialization.deserialize);
    }
    subscribeChargerControlActiveSessionAttempts(handler) {
        this.subscribeState("State_ChargerControlActiveSessionAttempts", handler, serialization_1.ChargerControlActiveSessionAttemptsSerialization.deserialize);
    }
    subscribeChargingTransactionTelemetryTracker(handler) {
        this.subscribeState("State_ChargingTransactionTelemetryTracker", handler, serialization_1.ChargingTransactionTelemetryTrackerSerialization.deserialize);
    }
    subscribeReceiptChargingSessionAttempts(handler) {
        this.subscribeState("State_ReceiptChargingSessionAttempts", handler, serialization_1.ReceiptChargingSessionAttemptsSerialization.deserialize);
    }
    subscribeChargerControlCtepParameterLog(handler) {
        this.subscribeState("State_ChargerControlCtepParameterLog", handler, serialization_1.ChargerControlCtepParameterLogSerialization.deserialize);
    }
    subscribePaymentTerminalControlActivePayments(handler) {
        this.subscribeState("State_PaymentTerminalControlActivePayments", handler, serialization_1.PaymentTerminalControlActivePaymentsSerialization.deserialize);
    }
    subscribePaymentTerminalControlProcessingPayments(handler) {
        this.subscribeState("State_PaymentTerminalControlProcessingPayments", handler, serialization_1.PaymentTerminalControlProcessingPaymentsSerialization.deserialize);
    }
    subscribePaymentTerminalControlCompletedPayments(handler) {
        this.subscribeState("State_PaymentTerminalControlCompletedPayments", handler, serialization_1.PaymentTerminalControlCompletedPaymentsSerialization.deserialize);
    }
    subscribePaymentTerminalControlPendingPreauths(handler) {
        this.subscribeState("State_PaymentTerminalControlPendingPreauths", handler, serialization_1.PaymentTerminalControlPendingPreauthsSerialization.deserialize);
    }
    subscribePaymentTerminalControlCachedPaymentMethod(handler) {
        this.subscribeState("State_PaymentTerminalControlCachedPaymentMethod", handler, serialization_1.PaymentTerminalControlCachedPaymentSerialization.deserialize);
    }
    subscribePaymentTerminalControlActiveMemberships(handler) {
        this.subscribeState("State_PaymentTerminalControlActiveMemberships", handler, serialization_1.PaymentTerminalControlActiveMembershipsSerialization.deserialize);
    }
    subscribePaymentTerminalControlPresentedPayments(handler) {
        this.subscribeState("State_PaymentTerminalControlPresentedPayments", handler, serialization_1.PaymentTerminalControlPresentedPaymentsSerialization.deserialize);
    }
    subscribeChargerControlChargerConfiguration(handler) {
        this.subscribeState("State_ChargerControlChargerConfiguration", handler, serialization_1.ChargerConfigurationSerialization.deserialize);
    }
    subscribeChargerControlChargerStatus(handler) {
        this.subscribeState("State_ChargerControlChargerStatus", handler, serialization_1.ChargerStatusSerialization.deserialize);
    }
    subscribeChargerControlCloudChargerOperatingStatus(handler) {
        this.subscribeState("State_ChargerControlCloudChargerOperatingStatus", handler, serialization_1.CloudChargerOperatingStatusSerialization.deserialize);
    }
    subscribeChargerControlPricing(handler) {
        this.subscribeState("State_ChargerControlPricing", handler, serialization_1.money_PricingModelSerialization.deserialize);
    }
    subscribePaymentTerminalControlTerminalStatus(handler) {
        this.subscribeState("State_PaymentTerminalControlTerminalStatus", handler, serialization_1.PaymentTerminalControlTerminalStatusSerialization.deserialize);
    }
    subscribePaymentTerminalControlMetrics(handler) {
        this.subscribeState("State_PaymentTerminalControlMetrics", handler, serialization_1.PaymentTerminalControlMetricsSerialization.deserialize);
    }
    subscribeChargerUIActivePort(handler) {
        this.subscribeState("State_ChargerUIActivePort", handler, serialization_1.ChargerUIActivePortSerialization.deserialize);
    }
    subscribeChargerUIFullscreenTakeover(handler) {
        this.subscribeState("State_ChargerUIFullscreenTakeover", handler, serialization_1.ChargerUIFullscreenTakeoverSerialization.deserialize);
    }
    subscribeChargerUIStatus(handler) {
        this.subscribeState("State_ChargerUIStatus", handler, serialization_1.ChargerUIStatusSerialization.deserialize);
    }
    subscribeChargerControlUIScreenStatus(handler) {
        this.subscribeState("State_ChargerControlUIScreenStatus", handler, serialization_1.ChargerControlUIScreenStatusSerialization.deserialize);
    }
    subscribeChargerControlTransactionStatus(handler) {
        this.subscribeState("State_ChargerControlTransactionStatus", handler, serialization_1.ChargerControlTransactionStatusSerialization.deserialize);
    }
    subscribeSimDispenserControlSafetyMicro(handler) {
        this.subscribeState("State_SimDispenserControlSafetyMicro", handler, serialization_1.SimDispenserControlSafetyMicroOutSerialization.deserialize);
    }
    subscribeSimDispenserControlHvPs(handler) {
        this.subscribeState("State_SimDispenserControlHvPs", handler, serialization_1.SimDispenserControlHvPsOutSerialization.deserialize);
    }
    subscribeSimDispenserControlEvseCommands(handler) {
        this.subscribeState("State_SimDispenserControlEvseCommands", handler, serialization_1.SimDispenserControlEvseCommandsSerialization.deserialize);
    }
    subscribeTestRackPowerSourceCommand(handler) {
        this.subscribeState("State_TestRackPowerSourceCommand", handler, serialization_1.TestRackPowerCommandSerialization.deserialize);
    }
    subscribeTestRackPowerSourceStatus(handler) {
        this.subscribeState("State_TestRackPowerSourceStatus", handler, serialization_1.TestRackPowerStatusSerialization.deserialize);
    }
    subscribeTestRackPowerSinkCommand(handler) {
        this.subscribeState("State_TestRackPowerSinkCommand", handler, serialization_1.TestRackPowerCommandSerialization.deserialize);
    }
    subscribeTestRackPowerSinkStatus(handler) {
        this.subscribeState("State_TestRackPowerSinkStatus", handler, serialization_1.TestRackPowerStatusSerialization.deserialize);
    }
    subscribeTestRackRelayCommand(handler) {
        this.subscribeState("State_TestRackRelayCommand", handler, serialization_1.TestRackRelaysSerialization.deserialize);
    }
    subscribeTestRackRelayStatus(handler) {
        this.subscribeState("State_TestRackRelayStatus", handler, serialization_1.TestRackRelaysSerialization.deserialize);
    }
    subscribeTestRackEvGpioCommand(handler) {
        this.subscribeState("State_TestRackEvGpioCommand", handler, serialization_1.TestRackEvGpioCommandSerialization.deserialize);
    }
    subscribeTestRackEvStatus(handler) {
        this.subscribeState("State_TestRackEvStatus", handler, serialization_1.TestRackEvStatusSerialization.deserialize);
    }
    subscribeChargerControlPluggedIn(handler) {
        this.subscribeEvent("Event_ChargerControlPluggedIn", handler, serialization_1.ChargerControlChargingPortStateSerialization.deserialize);
    }
    subscribeMembershipPresented(handler) {
        this.subscribeEvent("Event_MembershipPresented", handler, serialization_1.MembershipTransactionSerialization.deserialize);
    }
    subscribeMembershipError(handler) {
        this.subscribeEvent("Event_MembershipError", handler, serialization_1.MembershipTransactionSerialization.deserialize);
    }
    subscribeMembershipValidated(handler) {
        this.subscribeEvent("Event_MembershipValidated", handler, serialization_1.MembershipTransactionSerialization.deserialize);
    }
    subscribePaymentPresented(handler) {
        this.subscribeEvent("Event_PaymentPresented", handler, serialization_1.PaymentTransactionSerialization.deserialize);
    }
    subscribePaymentAuthorized(handler) {
        this.subscribeEvent("Event_PaymentAuthorized", handler, serialization_1.PaymentTransactionSerialization.deserialize);
    }
    subscribePaymentAuthorizationError(handler) {
        this.subscribeEvent("Event_PaymentAuthorizationError", handler, serialization_1.PaymentTransactionSerialization.deserialize);
    }
    subscribePaymentExpired(handler) {
        this.subscribeEvent("Event_PaymentExpired", handler, serialization_1.PaymentTransactionSerialization.deserialize);
    }
    subscribePaymentCancelled(handler) {
        this.subscribeEvent("Event_PaymentCancelled", handler, serialization_1.PaymentTransactionSerialization.deserialize);
    }
    subscribePaymentCaptureError(handler) {
        this.subscribeEvent("Event_PaymentCaptureError", handler, serialization_1.PaymentTransactionSerialization.deserialize);
    }
    subscribePaymentCaptureDeferred(handler) {
        this.subscribeEvent("Event_PaymentCaptureDeferred", handler, serialization_1.PaymentTransactionSerialization.deserialize);
    }
    subscribeUseMembershipAsPayment(handler) {
        this.subscribeEvent("Event_UseMembershipAsPayment", handler, serialization_1.PortRequestSerialization.deserialize);
    }
    subscribeSkipMembershipValidation(handler) {
        this.subscribeEvent("Event_SkipMembershipValidation", handler, serialization_1.PortRequestSerialization.deserialize);
    }
    subscribeConfirmMembershipInformProceed(handler) {
        this.subscribeEvent("Event_ConfirmMembershipInformProceed", handler, serialization_1.PortRequestSerialization.deserialize);
    }
    subscribeRequestMembershipValidation(handler) {
        this.subscribeEvent("Event_RequestMembershipValidation", handler, serialization_1.MembershipIdentifierSubmissionSerialization.deserialize);
    }
    subscribeRegisterMemberIdentifier(handler) {
        this.subscribeEvent("Event_RegisterMemberIdentifier", handler, serialization_1.MembershipIdentifierSubmissionSerialization.deserialize);
    }
    subscribeRequestOcppIdTokenAuthorization(handler) {
        this.subscribeEvent("Event_RequestOcppIdTokenAuthorization", handler, serialization_1.OcppIdTokenAuthorizationSerialization.deserialize);
    }
    subscribeOcppIdTokenAuthorizationResolved(handler) {
        this.subscribeEvent("Event_OcppIdTokenAuthorizationResolved", handler, serialization_1.OcppIdTokenAuthorizationSerialization.deserialize);
    }
    subscribeCancelTransaction(handler) {
        this.subscribeEvent("Event_CancelTransaction", handler, serialization_1.PortRequestSerialization.deserialize);
    }
    subscribeStopChargingSessionRequest(handler) {
        this.subscribeEvent("Event_StopChargingSessionRequest", handler, serialization_1.PortRequestSerialization.deserialize);
    }
    subscribeChargingTransactionCompleted(handler) {
        this.subscribeEvent("Event_ChargingTransactionCompleted", handler, serialization_1.ChargingSessionAttemptSerialization.deserialize);
    }
    subscribePaymentTerminalControlPaymentCompleted(handler) {
        this.subscribeEvent("Event_PaymentTerminalControlPaymentCompleted", handler, serialization_1.PaymentTransactionSerialization.deserialize);
    }
    subscribeGenerateReceipt(handler) {
        this.subscribeEvent("Event_GenerateReceipt", handler, serialization_1.GenerateReceiptSerialization.deserialize);
    }
    subscribeChargerUIChangeActivePort(handler) {
        this.subscribeEvent("Event_ChargerUIChangeActivePort", handler, serialization_1.ChargerUIActivePortSerialization.deserialize);
    }
    subscribeChargerUISendFeedback(handler) {
        this.subscribeEvent("Event_ChargerUISendFeedback", handler, serialization_1.ChargerUISendFeedbackSerialization.deserialize);
    }
    subscribeChargerUISendOnScreenValidationFeedback(handler) {
        this.subscribeEvent("Event_ChargerUISendOnScreenValidationFeedback", handler, serialization_1.ChargerUISendOnScreenValidationFeedbackSerialization.deserialize);
    }
    subscribeReceivedOcpiTrackingId(handler) {
        this.subscribeEvent("Event_ReceivedOcpiTrackingId", handler, serialization_1.ReceivedOcpiTrackingIdSerialization.deserialize);
    }
    subscribePaymentTerminalControlEMVCardPayload(handler) {
        this.subscribeEvent("Event_PaymentTerminalControlEMVCardPayload", handler, serialization_1.PaymentTerminalControlEMVCardPayloadSerialization.deserialize);
    }
    subscribePaymentTerminalControlRequestCardPaymentCapture(handler) {
        this.subscribeEvent("Event_PaymentTerminalControlRequestCardPaymentCapture", handler, serialization_1.PaymentTransactionSerialization.deserialize);
    }
    subscribeSimChargerControlPluggedIn(handler) {
        this.subscribeEvent("Event_SimChargerControlPluggedIn", handler, serialization_1.ChargerControlChargingPortStateSerialization.deserialize);
    }
    subscribeSimPaymentTerminalControlPayment(handler) {
        this.subscribeEvent("Event_SimPaymentTerminalControlPayment", handler, serialization_1.SimulationPaymentSerialization.deserialize);
    }
    subscribeSimChargerControlDeratingReason(handler) {
        this.subscribeEvent("Event_SimChargerControlDeratingReason", handler, serialization_1.SimChargerControlDeratingReasonStateSerialization.deserialize);
    }
    subscribeSimChargerControlErrorCode(handler) {
        this.subscribeEvent("Event_SimChargerControlErrorCode", handler, serialization_1.SimChargerControlErrorCodeStateSerialization.deserialize);
    }
    subscribeDiscoControlManualCommand(handler) {
        this.subscribeEvent("Event_DiscoControlManualCommand", handler, serialization_1.DispenserControlManualCommandsSerialization.deserialize);
    }
    subscribeCoolioManualCommand(handler) {
        this.subscribeEvent("Event_CoolioManualCommand", handler, serialization_1.CoolioManualCommandsSerialization.deserialize);
    }
    subscribeSksgV2FirmwareUpdateCommand(handler) {
        this.subscribeEvent("Event_SksgV2FirmwareUpdateCommand", handler, serialization_1.SksgV2FirmwareUpdateCommandSerialization.deserialize);
    }
    subscribeSksgV2RebootCommand(handler) {
        this.subscribeEvent("Event_SksgV2RebootCommand", handler, serialization_1.SksgV2RebootCommandSerialization.deserialize);
    }
}
exports.TypedEventBusClient = TypedEventBusClient;
